import { IAction } from "src/js/actions/IshAction";
import { FULFILLED } from "src/js/common/actions/ActionUtils";
import { INIT_REQUEST, SHOW_MESSAGES } from "../../../actions/Actions";
import {
  APPLY_CORPORATE_PASS,
  CHANGE_TAB, CHECKOUT_COMPLETE_STRIPE_CC_PAYMENT,
  CHECKOUT_RESET_PAYMENT_SESSION,
  GENERATE_WAITING_COURSES_RESULT_DATA,
  GET_CORPORATE_PASS_REQUEST,
  RESET_CORPORATE_PASS,
  RESET_PAYMENT_STATE,
  RESET_PAYMENT_STATE_ON_INIT,
  SET_IFRAME_URL,
  SET_PAYMENT_DATA,
  SET_PAYMENT_FETCHING,
  UPDATE_PAYMENT_STATUS,
} from "../actions/Actions";
import { State } from "./State";

export const Reducer = (state: State = new State(), action: IAction<any>): State => {
  switch (action.type) {

    case SET_PAYMENT_FETCHING: {
      return {
        ...state,
        fetching: action.payload
      }
    }

    case CHECKOUT_COMPLETE_STRIPE_CC_PAYMENT: {
      return {
        ...state,
        fetching: true
      }
    }

    case SET_PAYMENT_DATA: {
      const {merchantReference, ccFormUrl, sessionId, clientSecret} = action.payload;

      return {
        ...state,
        merchantReference,
        sessionId,
        clientSecret,
        iframeUrl: ccFormUrl,
        fetching: false,
      };
    }

    case SET_IFRAME_URL: {
      return {
        ...state,
        iframeUrl: action.payload,
      };
    }

    case CHECKOUT_RESET_PAYMENT_SESSION: {
      return {
        ...state,
        fetching: true,
      };
    }

    case UPDATE_PAYMENT_STATUS:
      return {
        ...state,
        value: action.payload,
      };

    case APPLY_CORPORATE_PASS:
      return {
        ...state,
        corporatePass: action.payload,
      };

    case RESET_CORPORATE_PASS:
      return {
        ...state,
        corporatePass: {},
      };

    case CHANGE_TAB:
      return {
        ...state,
        currentTab: action.payload,
      };
    case GET_CORPORATE_PASS_REQUEST:
      return {
        ...state,
        fetching: true,
      };

    case FULFILLED(GET_CORPORATE_PASS_REQUEST):
    case SHOW_MESSAGES:
    case INIT_REQUEST:
      return {
        ...state,
        fetching: false,
      };

    case RESET_PAYMENT_STATE:
      return new State();

    case RESET_PAYMENT_STATE_ON_INIT:
      return {
        ...state,
        resetOnInit: true,
      };

    case GENERATE_WAITING_COURSES_RESULT_DATA:
      return {
        ...state,
        result: action.payload,
      };

    default:
      return state;
  }
};
